import { forwardRef } from 'react'
import {
  FieldValues,
  useController,
  FieldPath,
  UseControllerProps,
} from 'react-hook-form'
import IntegerField, { IntegerFieldProps } from '../inputs/IntegerField'

type FormIntegerFieldProps<FormValues extends FieldValues> = {
  name: FieldPath<FormValues>
  label: string
  useControllerProps?: Omit<UseControllerProps<FormValues>, 'name'>
} & IntegerFieldProps

const FormIntegerField = forwardRef(function FormIntegerField<
  FormValues extends FieldValues,
>(
  {
    name,
    required,
    useControllerProps,
    ...props
  }: FormIntegerFieldProps<FormValues>,
  ref: React.Ref<HTMLInputElement>,
) {
  const { field } = useController<FormValues>({
    name,
    ...useControllerProps,
    rules: {
      required,
      ...useControllerProps?.rules,
    },
  })

  return <IntegerField {...props} {...field} inputRef={ref} />
})

export default FormIntegerField
